<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('maquinarias')">Maquinaria:</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.codigo }}
    </h1>
    <trashed-message v-if="maquinaria.deleted_at" class="mb-6" @restore="restore">
     Maquinaria Removed!
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.codigo" :error="form.errors.codigo" class="pr-6 pb-8 w-full lg:w-1/4" label="Código" required/>
          <select-input v-model="form.empresa_propietaria" :error="form.errors.empresa_propietaria" class="pr-6 pb-8 w-full lg:w-1/4" label="Empresa Propietaria" required>
             <option>Guadalupe</option>
            <option>Jose Luis Zavala</option>
            <option>Petrusmin</option>
            <option>San Pio</option>
            <option>YeshuaCons</option>
            <option>Cofiza Scc</option>
            <option>Geomax</option>
            <option>Urbymaq</option>
            <option>Tecfin Scc</option>
          </select-input>  
          <text-input v-model="form.clase" :error="form.errors.clase" class="pr-6 pb-8 w-full lg:w-1/4" label="Clase" required/>
          <text-input v-model="form.placas" :error="form.errors.placas" class="pr-6 pb-8 w-full lg:w-1/4" label="Placas" required/>
         <select-input v-model="form.grupo" :error="form.errors.grupo" class="pr-6 pb-8 w-full lg:w-1/4" label="Grupo" required>
             <option>Maquinaria</option>
            <option>Busetas</option>
            <option>General</option>
          </select-input>  
          <text-input v-model="form.marca" :error="form.errors.marca" class="pr-6 pb-8 w-full lg:w-1/4" label="Marca" required/>
          <text-input v-model="form.modelo" :error="form.errors.modelo" class="pr-6 pb-8 w-full lg:w-1/4" label="Modelo" required/>
           <select-input v-model="form.tipo" :error="form.errors.tipo" class="pr-6 pb-8 w-full lg:w-1/4" label="Tipo de Combustible" required>
             <option>Diesel Premium</option>
            <option>Extra</option>
            <option>Super</option>
          </select-input>  
          <text-input v-model="form.motor" :error="form.errors.motor" class="pr-6 pb-8 w-full lg:w-1/4" label="Motor" required/>
            <text-input v-model="form.chasis" :error="form.errors.chasis" class="pr-6 pb-8 w-full lg:w-1/4" label="Chasis" required/>
          <text-input v-model="form.potencia" :error="form.errors.pontencia" class="pr-6 pb-8 w-full lg:w-1/4" label="Potencia" required/>
          <text-input v-model="form.color" :error="form.errors.color" class="pr-6 pb-8 w-full lg:w-1/4" label="Color" required/>
          <text-input v-model="form.ano_fabricacion" :error="form.errors.ano_fabricacion" class="pr-6 pb-8 w-full lg:w-1/4" label="Año de Fabricación" required/>
          <text-input v-model="form.odometro_anterior" :error="form.errors.odometro_anterior" class="pr-6 pb-8 w-full lg:w-1/4" label="Odometro Anterior" required/>
        <text-input v-model="form.odometro_actual" :error="form.errors.odometro_actual" class="pr-6 pb-8 w-full lg:w-1/4" label="Odometro Actual" required/>
          <text-input v-model="form.observaciones" :error="form.errors.observaciones" class="pr-6 pb-8 w-full lg:w-2/4" label="Observaciones" required/>
          <text-input v-model="form.consumo_litro" :error="form.errors.consumo_litro" class="pr-6 pb-8 w-full lg:w-2/4" label="Consumo en Litro/Hora" required/>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="$page.props.auth.user.rol !='Cliente'  && !maquinaria.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Maquinaria</button>
          <loading-button :loading="form.processing" v-if="$page.props.auth.user.rol !='Cliente'" class="btn-indigo ml-auto" type="submit">Guardar Maquinaria</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.codigo}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    maquinaria: Object,
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        codigo: this.maquinaria.codigo,
        empresa_propietaria: this.maquinaria.empresa_propietaria,
        clase: this.maquinaria.clase,
        placas: this.maquinaria.placas,
        grupo: this.maquinaria.grupo,
        marca: this.maquinaria.marca,
        modelo: this.maquinaria.modelo,
        motor: this.maquinaria.motor,
        chasis: this.maquinaria.chasis,
        potencia: this.maquinaria.potencia,
        tipo: this.maquinaria.tipo,
        color: this.maquinaria.color,
        ano_fabricacion: this.maquinaria.ano_fabricacion,
        odometro_anterior: this.maquinaria.odometro_anterior,
        odometro_actual: this.maquinaria.odometro_actual,
        consumo_litro: this.maquinaria.consumo_litro,
        observaciones: this.maquinaria.observaciones,

      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('maquinarias.update', this.maquinaria.id))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('maquinarias.destroy', this.maquinaria.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('maquinarias.restore', this.maquinaria.id))
      }
    },
  },
}
</script>
